import { type Action } from 'redux';
import {
  ActionsObservable,
  combineEpics,
  ofType,
  StateObservable,
} from 'redux-observable';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';

import { SUBSCRIBE_RECENT_TRADE, UNSUBSCRIBE_OB_RT } from 'actionTypes/socket';
import {
  PUBLIC_SOCKET_CHANNELS,
  PUBLIC_SOCKET_OUTGOING_MESSAGE_TYPES,
} from 'constants/publicSocket';
import { selectedProductSelector } from 'selectors/tradeSelectors';
import { getRecentTrades } from 'stores/store.globalActions/trades';
import IState from 'types/Istore';
import type { AggTradesPayload } from 'types/RecentTrades';

import { publicWsSubject } from './publicSocket';
import { payloadGenerator } from './socket';

const recentTradeChannel = (symbols: string[]): Observable<AggTradesPayload> =>
  publicWsSubject.multiplex(
    () =>
      payloadGenerator(
        PUBLIC_SOCKET_OUTGOING_MESSAGE_TYPES.SUBSCRIBE,
        PUBLIC_SOCKET_CHANNELS.AGGREGATED_TRADES,
        symbols
      ),
    () =>
      payloadGenerator(
        PUBLIC_SOCKET_OUTGOING_MESSAGE_TYPES.UNSUBSCRIBE,
        PUBLIC_SOCKET_CHANNELS.AGGREGATED_TRADES,
        symbols
      ),
    message => message.type === PUBLIC_SOCKET_CHANNELS.AGGREGATED_TRADES
  ) as Observable<AggTradesPayload>;

export const subscribeRecentTradeEpic = (
  action$: ActionsObservable<Action>,
  state$: StateObservable<IState>
) =>
  action$.pipe(
    ofType(SUBSCRIBE_RECENT_TRADE),
    mergeMap(action => {
      // @ts-ignore - lib type issue
      return recentTradeChannel([action.payload]).pipe(
        takeUntil(action$.ofType(UNSUBSCRIBE_OB_RT)),
        catchError(err => {
          console.error('Recent', err);
          return EMPTY;
        })
      );
    }),
    map(message => {
      const selectedProduct = selectedProductSelector(state$.value);
      return getRecentTrades(message, selectedProduct?.symbol ?? '');
    })
  );

export default combineEpics(subscribeRecentTradeEpic);
